import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import TrendingRoutes from './TrendingRoutes';
import WhyBooking from './WhyBooking';
import "../App.css";
import slide1 from "../Content/Flight_Images/Slider1.png";
import slide2 from "../Content/Flight_Images/Slider2.jpg";
import slide3 from "../Content/Flight_Images/Slider3.jpg";
const DEFAULT_FROM = { city: "Delhi", code: "DEL", name: "Indira Gandhi International Airport", domestic: true };
const DEFAULT_TO = { city: "Mumbai", code: "BOM", name: "Chhatrapati Shivaji Maharaj International Airport", domestic: true };

// Airport India ka hai (domestic) ya bahar ka (international)?
const isIndianAirport = (a) => {
    if (!a) return false;
    const country = String(a.CountryName || a.Country || a.CountryCode || a.Nationality || "").toLowerCase();
    const code = String(a.CountryCode || a.Country || "").toUpperCase();
    if (country.includes("india") || code === "IN" || code === "IND") return true;
    return a.IsDomestic === true;
};
const toLocalDateStr = (d) => {
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${y}-${m}-${day}`;
};

const CLASS_MAP = {
    "Economy": 0,
    "Premium Economy": 1,
    "Business": 2,
    "First Class": 3
};

const MONTH_NAMES = ["january", "february", "march", "april", "may", "june", "july",
    "august", "september", "october", "november", "december"];

function Index() {
    const navigate = useNavigate();

    const [tripType, setTripType] = useState("O"); 
    const [isSearching, setIsSearching] = useState(false);

    // ===== CHATBOT STATES =====
    const [isChatOpen, setIsChatOpen] = useState(false);
    const [messages, setMessages] = useState([]);
    const [userInput, setUserInput] = useState("");
    const [isBotTyping, setIsBotTyping] = useState(false);
    const [pendingFlight, setPendingFlight] = useState(null);

    const [from, setFrom] = useState(DEFAULT_FROM);
    const [to, setTo] = useState(DEFAULT_TO);

    const [departDate, setDepartDate] = useState("");
    const [returnDate, setReturnDate] = useState("");
    const [departDisplay, setDepartDisplay] = useState({});
    const [returnDisplay, setReturnDisplay] = useState({});

    const [adults, setAdults] = useState(1);
    const [children, setChildren] = useState(0);
    const [infants, setInfants] = useState(0);
    const [travelClass, setTravelClass] = useState("Economy");
    const [showTravelerDropdown, setShowTravelerDropdown] = useState(false);
    const [airports, setAirports] = useState([]);
    const [airportsStatus, setAirportsStatus] = useState("loading"); 
    const [fromQuery, setFromQuery] = useState(DEFAULT_FROM.city);
    const [toQuery, setToQuery] = useState(DEFAULT_TO.city);
    const [fromSuggestions, setFromSuggestions] = useState([]);
    const [toSuggestions, setToSuggestions] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);
    const bgSlides = [slide1, slide2, slide3];
    const fromRef = useRef(null);
    const toRef = useRef(null);
    const travelerRef = useRef(null);
    const departInputRef = useRef(null);
    const returnInputRef = useRef(null);
    const chatBodyRef = useRef(null);

    const fromSuggestionsRef = useRef([]);
    const toSuggestionsRef = useRef([]);
    useEffect(() => { fromSuggestionsRef.current = fromSuggestions; }, [fromSuggestions]);
    useEffect(() => { toSuggestionsRef.current = toSuggestions; }, [toSuggestions]);

    useEffect(() => {
        const AIRPORTS_ENDPOINT = "https://promo.namantechnolab.com/api/Air/Airports";
        const CACHE_KEY = "airports_v2"; // domestic + international (purana "airports" cache sirf domestic tha)

        const toArr = (d) =>
            Array.isArray(d) ? d : Array.isArray(d?.data) ? d.data : [];

        const fetchList = async (isDomestic) => {
            const res = await fetch(AIRPORTS_ENDPOINT, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    APIToken: null,
                    AgencyKey: "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
                    AccountNo: 11,
                    IsDomestic: isDomestic,
                    IsB2B: false,
                }),
            });
            if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
            return toArr(await res.json());
        };

        const loadAirports = async () => {
            const stored = localStorage.getItem(CACHE_KEY);
            if (stored) {
                try {
                    const parsed = JSON.parse(stored);
                    if (Array.isArray(parsed) && parsed.length > 0) {
                        setAirports(parsed);
                        setAirportsStatus("ready");
                        return;
                    }
                } catch (e) {
                    localStorage.removeItem(CACHE_KEY);
                }
            }

            // Domestic aur international dono list ek saath mangwao
            const [domRes, intlRes] = await Promise.allSettled([
                fetchList(true),
                fetchList(false),
            ]);

            if (domRes.status === "rejected") console.error("Domestic airports failed:", domRes.reason?.message);
            if (intlRes.status === "rejected") console.error("International airports failed:", intlRes.reason?.message);

            const domestic = domRes.status === "fulfilled" ? domRes.value.filter(isIndianAirport) : [];
            const international = intlRes.status === "fulfilled" ? intlRes.value : [];

            // Merge + duplicate airport code hatao
            const seen = new Set();
            const merged = [];
            [...domestic, ...international].forEach((a) => {
                const key = a.AirportCode;
                if (!key || seen.has(key)) return;
                seen.add(key);
                merged.push(a);
            });

            console.log(`Airports loaded: ${domestic.length} domestic, ${international.length} international, ${merged.length} total`);
            if (merged[0]) console.log("Sample airport:", merged[0]);

            if (merged.length > 0) {
                setAirports(merged);
                setAirportsStatus("ready");
                localStorage.setItem(CACHE_KEY, JSON.stringify(merged));
            } else {
                setAirportsStatus("error");
            }
        };

        loadAirports();
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (fromRef.current && !fromRef.current.contains(event.target)) {
                setFromSuggestions([]);
            }
            if (toRef.current && !toRef.current.contains(event.target)) {
                setToSuggestions([]);
            }
            if (travelerRef.current && !travelerRef.current.contains(event.target)) {
                setShowTravelerDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);

        setDepartDate(toLocalDateStr(today));
        setReturnDate(toLocalDateStr(tomorrow));

        updateDateDisplay(today, setDepartDisplay);
        updateDateDisplay(tomorrow, setReturnDisplay);
    }, []);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % bgSlides.length);
        }, 5000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (chatBodyRef.current) {
            chatBodyRef.current.scrollTop = chatBodyRef.current.scrollHeight;
        }
    }, [messages, isBotTyping]);
    const parseLocalDate = (str) => {
        const [y, m, d] = str.split("-").map(Number);
        return new Date(y, m - 1, d);
    };

    const updateDateDisplay = (date, setter) => {
        if (!date || isNaN(date.getTime())) return;
        const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        setter({
            day: date.getDate(),
            month: months[date.getMonth()],
            year: date.getFullYear(),
            dayName: dayNames[date.getDay()]
        });
    };

    const handleSwap = () => {
        const tempFrom = from;
        const tempTo = to;
        setFrom(tempTo);
        setTo(tempFrom);
        setFromQuery(tempTo.city);
        setToQuery(tempFrom.city);
    };

    const handleDepartDateChange = (e) => {
        if (!e.target.value) return;
        const newDate = parseLocalDate(e.target.value);
        const today = new Date(); today.setHours(0, 0, 0, 0);
        if (newDate < today) return; // past date reject
        setDepartDate(e.target.value);
        updateDateDisplay(newDate, setDepartDisplay);
        if (returnDate && parseLocalDate(returnDate) < newDate) {
            setReturnDate(e.target.value);
            updateDateDisplay(newDate, setReturnDisplay);
        }
    };

    const handleReturnDateChange = (e) => {
        if (!e.target.value) return;
        const newDate = parseLocalDate(e.target.value);
        setReturnDate(e.target.value);
        updateDateDisplay(newDate, setReturnDisplay);
    };

    const getFilteredAirports = (query) => {
        if (!Array.isArray(airports)) return [];
        const cleanQuery = (query || "").trim().toLowerCase();
        const rank = (a) => {
            const code = (a.AirportCode || "").toLowerCase();
            const city = (a.CityName || "").toLowerCase();
            if (code === cleanQuery) return 0;
            if (city.startsWith(cleanQuery)) return 1;
            if (code.startsWith(cleanQuery)) return 2;
            return 3;
        };
        return airports
            .filter(a =>
                (a.AirportCode && a.AirportCode.toLowerCase().includes(cleanQuery)) ||
                (a.AirportName && a.AirportName.toLowerCase().includes(cleanQuery)) ||
                (a.CityName && a.CityName.toLowerCase().includes(cleanQuery))
            )
            .sort((a, b) =>
                rank(a) - rank(b) ||
                Number(isIndianAirport(b)) - Number(isIndianAirport(a)) ||
                (Number(a.CountryCounter) || 0) - (Number(b.CountryCounter) || 0)
            );
    };

    const handleInputFocus = (type, e) => {
        const query = type === "from" ? fromQuery : toQuery;
        const selectedCity = type === "from" ? from.city : to.city;

        if (query === selectedCity && e?.target) {
            e.target.select();
        }

        if (query.trim().length >= 3 && airports.length > 0) {
            const filtered = getFilteredAirports(query);
            if (type === "from") setFromSuggestions(filtered.slice(0, 10));
            else setToSuggestions(filtered.slice(0, 10));
        }
    };

    const handleFromChange = (e) => {
        const value = e.target.value;
        setFromQuery(value);
        if (value.trim().length >= 3) {
            setFromSuggestions(getFilteredAirports(value).slice(0, 10));
        } else {
            setFromSuggestions([]);
        }
    };

    const handleToChange = (e) => {
        const value = e.target.value;
        setToQuery(value);
        if (value.trim().length >= 3) {
            setToSuggestions(getFilteredAirports(value).slice(0, 10));
        } else {
            setToSuggestions([]);
        }
    };

    const selectFromAirport = (airport) => {
        setFrom({ city: airport.CityName, code: airport.AirportCode, name: airport.AirportName, domestic: isIndianAirport(airport) });
        setFromQuery(airport.CityName);
        setFromSuggestions([]);
    };

    const selectToAirport = (airport) => {
        setTo({ city: airport.CityName, code: airport.AirportCode, name: airport.AirportName, domestic: isIndianAirport(airport) });
        setToQuery(airport.CityName);
        setToSuggestions([]);
    };

    const handleFromBlur = () => {
        setTimeout(() => {
            if (fromSuggestionsRef.current.length === 0) {
                setFromQuery((prevQuery) => (prevQuery.trim() === "" ? from.city : prevQuery));
            }
            setFromSuggestions([]);
        }, 150);
    };

    const handleToBlur = () => {
        setTimeout(() => {
            if (toSuggestionsRef.current.length === 0) {
                setToQuery((prevQuery) => (prevQuery.trim() === "" ? to.city : prevQuery));
            }
            setToSuggestions([]);
        }, 150);
    };

    // ===== CHATBOT: quick heuristic to decide if a message looks like a flight route query =====
    const looksLikeFlightQuery = (text) => {
        if (!text) return false;
        const lower = text.toLowerCase();
        return /[a-z]+[a-z\s]*\s+to\s+[a-z]+[a-z\s]*/.test(lower);
    };

    const findCityInText = (text) => {
        const words = text.toLowerCase().split(/\s+/).filter(Boolean);
        let bestMatch = null;

        for (const airport of airports) {
            if (!airport.CityName) continue;
            const cityWords = airport.CityName.toLowerCase().split(/\s+/).filter(Boolean);

            for (let i = 0; i <= words.length - cityWords.length; i++) {
                const slice = words.slice(i, i + cityWords.length).join(" ");
                if (slice === cityWords.join(" ")) {
                    if (!bestMatch || airport.CityName.length > bestMatch.CityName.length) {
                        bestMatch = airport;
                    }
                }
            }
        }

        return bestMatch;
    };

    const parseFlightQuery = (text) => {
        const lower = text.toLowerCase();

        const match = lower.match(/([a-z\s]+?)\s+to\s+([a-z\s]+?)(?:\s+next week|\s+tomorrow|$)/);
        if (!match) return null;

        const fromWord = match[1].trim();
        const toWord = match[2].trim();

        const fromCity = findCityInText(fromWord);
        const toCity = findCityInText(toWord);

        if (!fromCity || !toCity) return null;

        let dateStr = null;
        if (lower.includes("tomorrow")) {
            const travelDate = new Date();
            travelDate.setDate(travelDate.getDate() + 1);
            dateStr = toLocalDateStr(travelDate);
        }

        return { fromCity, toCity, dateStr };
    };

    const parseDateReply = (text) => {
        const raw = (text || "").trim().toLowerCase();
        if (!raw) return null;

        if (raw.includes("tomorrow")) {
            const d = new Date();
            d.setDate(d.getDate() + 1);
            return d;
        }

        if (raw.includes("next week")) {
            const d = new Date();
            d.setDate(d.getDate() + 8);
            return d;
        }

        let m = raw.match(/^(\d{1,2})[\/\-](\d{1,2})[\/\-](\d{2,4})$/);
        if (m) {
            let [, dd, mm, yyyy] = m;
            if (yyyy.length === 2) yyyy = "20" + yyyy;
            const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
            if (!isNaN(d.getTime())) return d;
        }

        m = raw.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
        if (m) {
            const [, yyyy, mm, dd] = m;
            const d = new Date(Number(yyyy), Number(mm) - 1, Number(dd));
            if (!isNaN(d.getTime())) return d;
        }

        m = raw.match(/^(\d{1,2})\s+([a-z]+)(?:\s+(\d{4}))?$/);
        if (m) {
            const [, dd, monthWord, yyyy] = m;
            const monthIdx = MONTH_NAMES.findIndex(mn => mn.startsWith(monthWord));
            if (monthIdx !== -1) {
                const year = yyyy ? Number(yyyy) : new Date().getFullYear();
                let d = new Date(year, monthIdx, Number(dd));
                const todayMidnight = new Date(); todayMidnight.setHours(0, 0, 0, 0);
                if (!yyyy && d < todayMidnight) d = new Date(year + 1, monthIdx, Number(dd));
                if (!isNaN(d.getTime())) return d;
            }
        }

        m = raw.match(/^([a-z]+)\s+(\d{1,2}),?(?:\s+(\d{4}))?$/);
        if (m) {
            const [, monthWord, dd, yyyy] = m;
            const monthIdx = MONTH_NAMES.findIndex(mn => mn.startsWith(monthWord));
            if (monthIdx !== -1) {
                const year = yyyy ? Number(yyyy) : new Date().getFullYear();
                let d = new Date(year, monthIdx, Number(dd));
                const todayMidnight = new Date(); todayMidnight.setHours(0, 0, 0, 0);
                if (!yyyy && d < todayMidnight) d = new Date(year + 1, monthIdx, Number(dd));
                if (!isNaN(d.getTime())) return d;
            }
        }

        return null;
    };

    const searchFlights = (fromCity, toCity, dateStr) => {
        setMessages(prev => [...prev, {
            role: "bot",
            text: `${fromCity.CityName} se ${toCity.CityName} (${dateStr}) ke liye flights dhoondh raha hoon...`
        }]);

        const payload = {
            "APIToken": null,
            "AgencyKey": "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
            "AdultCount": 1,
            "ChildCount": 0,
            "InfantCount": 0,
            "PreferredAirlines": null,
            "Routs": [{
                Source: fromCity.AirportCode,
                InputSource: `${fromCity.AirportCode} - ${fromCity.AirportName}`,
                Destination: toCity.AirportCode,
                OutputSource: `${toCity.AirportCode} - ${toCity.AirportName}`,
                TravelDate: dateStr
            }],
            "TripType": 0,
            "TypeOfClass": CLASS_MAP[travelClass] ?? 0,
            "IsDomestic": isIndianAirport(fromCity) && isIndianAirport(toCity),
            "SetAirport": null,
            "IsB2B": false,
            "IsSpecailFlight": false,
            "FromCity": null,
            "Tocity": null,
            "TransactionId": 0,
            "EngineType": 0,
            "AccountNo": 11
        };

        const queryParams = new URLSearchParams({
            origin: fromCity.AirportCode,
            destination: toCity.AirportCode,
            date: dateStr,
            trip: "O"
        }).toString();

        setTimeout(() => {
            navigate(`/AirResponse/Index?${queryParams}`, { state: { searchData: payload } });
        }, 600);
    };

    const handleFlightQuery = (question) => {
        if (!question || !question.trim()) return;

        setMessages(prev => [...prev, { role: "user", text: question }]);
        setUserInput("");

        if (airportsStatus !== "ready") {
            setMessages(prev => [...prev, {
                role: "bot",
                text: "Airport data abhi load ho raha hai, kripya kuch second baad dobara try karein."
            }]);
            return;
        }

        const parsed = parseFlightQuery(question);

        if (!parsed) {
            setMessages(prev => [...prev, {
                role: "bot",
                text: "Sorry, main is query ko samajh nahi paya. Kripya 'City A to City B' format me poochein, jaise 'Mumbai to Delhi'."
            }]);
            return;
        }

        if (parsed.dateStr) {
            searchFlights(parsed.fromCity, parsed.toCity, parsed.dateStr);
            return;
        }

        setPendingFlight({ fromCity: parsed.fromCity, toCity: parsed.toCity });
        setMessages(prev => [...prev, {
            role: "bot",
            text: `${parsed.fromCity.CityName} se ${parsed.toCity.CityName} — aap kis date ko travel karna chahte hain? (jaise 2026-09-20 ya 20 September)`
        }]);
    };

    const getLocalBotReply = (question) => {
        const lower = question.toLowerCase();

        if (lower.includes("document") || lower.includes("passport") || lower.includes("visa")) {
            return "Domestic flights ke liye ek valid government photo ID (Aadhaar, PAN, Driving License, ya Passport) kaafi hai. International trips ke liye valid passport (kam se kam 6 mahine ki validity) aur zaroorat pade toh visa bhi chahiye hoga.";
        }
        if (lower.includes("plan") || lower.includes("trip") || lower.includes("itinerary")) {
            return "Bilkul, main madad kar sakta hoon! Bas mujhe batayein: aap kahan se kahan travel karna chahte hain aur kab? Jaise 'Mumbai to Goa next week'.";
        }
        if (lower.includes("baggage") || lower.includes("luggage")) {
            return "Baggage allowance airline aur travel class par depend karta hai — generally Economy mein 15-20kg check-in aur 7kg cabin baggage allowed hota hai. Exact limits ke liye apni booked airline check karein.";
        }
        if (lower.includes("cancel") || lower.includes("refund")) {
            return "Cancellation aur refund policy airline aur fare type par depend karti hai. Apni booking confirmation email mein fare rules dekhein, ya humari support team se contact karein.";
        }
        if (lower.includes("hi") || lower.includes("hello") || lower.includes("hey")) {
            return "Hi! Main Kudo hoon, aapka travel assistant. Aap mujhse flights dhoondhne ke liye 'City A to City B' format use kar sakte hain, jaise 'Mumbai to Delhi next week', ya travel se juda koi bhi sawaal pooch sakte hain.";
        }

        return "Main abhi seedhi flight searches mein sabse zyada helpful hoon — try 'City A to City B', jaise 'Mumbai to Delhi next week'. Aap chahe toh baggage, documents, ya trip planning se juda sawaal bhi pooch sakte hain.";
    };

    const handleGeneralQuery = (question) => {
        setMessages(prev => [...prev, { role: "user", text: question }]);
        setUserInput("");
        setIsBotTyping(true);
        setTimeout(() => {
            const reply = getLocalBotReply(question);
            setMessages(prev => [...prev, { role: "bot", text: reply }]);
            setIsBotTyping(false);
        }, 600);
    };

    const handleUserMessage = (question) => {
        if (!question || !question.trim()) return;

        if (pendingFlight) {
            setMessages(prev => [...prev, { role: "user", text: question }]);
            setUserInput("");

            const parsedDate = parseDateReply(question);
            if (!parsedDate) {
                setMessages(prev => [...prev, {
                    role: "bot",
                    text: "Sorry, date samajh nahi aayi. Kripya is format mein bataiye: 2026-09-20 ya 20 September."
                }]);
                return;
            }

            const dateStr = toLocalDateStr(parsedDate);
            const { fromCity, toCity } = pendingFlight;
            setPendingFlight(null);
            searchFlights(fromCity, toCity, dateStr);
            return;
        }

        if (airportsStatus === "ready") {
            const parsed = parseFlightQuery(question);
            if (parsed) {
                handleFlightQuery(question);
                return;
            }
        } else if (looksLikeFlightQuery(question)) {
            handleFlightQuery(question);
            return;
        }

        handleGeneralQuery(question);
    };

    const handleSearch = (e) => {
        e.preventDefault();
        setIsSearching(true);

        const routs = [
            {
                Source: from.code,
                InputSource: `${from.code} - ${from.name}`,
                Destination: to.code,
                OutputSource: `${to.code} - ${to.name}`,
                TravelDate: departDate
            }
        ];

        if (tripType === "R") {
            routs.push({
                Source: to.code,
                InputSource: `${to.code} - ${to.name}`,
                Destination: from.code,
                OutputSource: `${from.code} - ${from.name}`,
                TravelDate: returnDate
            });
        }

        const payload = {
            "APIToken": null,
            "AgencyKey": "02AD68F3-9AE6-4148-85B1-E61D1F03991F",
            "AdultCount": Number(adults) || 1,
            "ChildCount": Number(children) || 0,
            "InfantCount": Number(infants) || 0,
            "PreferredAirlines": null,
            "Routs": routs,
            "TripType": tripType === "O" ? 0 : 1,
            "TypeOfClass": CLASS_MAP[travelClass] ?? 0,
            "IsDomestic": from.domestic !== false && to.domestic !== false,
            "SetAirport": null,
            "IsB2B": false,
            "IsSpecailFlight": false,
            "FromCity": null,
            "Tocity": null,
            "TransactionId": 0,
            "EngineType": 0,
            "AccountNo": 11
        };

        const queryParams = new URLSearchParams({
            origin: from.code,
            destination: to.code,
            date: departDate,
            trip: tripType
        }).toString();

        navigate(`/AirResponse/Index?${queryParams}`, { state: { searchData: payload } });
    };

    const totalTravelers = adults + children + infants;

    return (
        <div className="fs-page">
            <section className="fs-hero">
                <div className="fs-hero-bg">
                    {bgSlides.map((img, idx) => (
                        <div
                            key={idx}
                            className="fs-hero-slide"
                            style={{
                                backgroundImage: `url(${img})`,
                                opacity: currentSlide === idx ? 1 : 0
                            }}
                        />
                    ))}
                    <div className="fs-hero-overlay" />
                </div>

                <div className="fs-hero-dots">
                    {bgSlides.map((_, idx) => (
                        <button
                            key={idx}
                            type="button"
                            aria-label={`Slide ${idx + 1}`}
                            className={`fs-dot ${currentSlide === idx ? "active" : ""}`}
                            onClick={() => setCurrentSlide(idx)}
                        />
                    ))}
                </div>

                <div className="fs-container">
                    <p className="fs-eyebrow">Fly further, spend less</p>
                    <h1 className="fs-heading">Domestic &amp; international flights</h1>
                    <p className="fs-subheading">Compare fares across airlines in seconds and lock in your seat.</p>

                    <div className="fs-card">
                        <div className="fs-triptype">
                            <button
                                type="button"
                                className={`fs-trip-btn ${tripType === "O" ? "active" : ""}`}
                                onClick={() => setTripType("O")}
                            >
                                One way
                            </button>
                            <button
                                type="button"
                                className={`fs-trip-btn ${tripType === "R" ? "active" : ""}`}
                                onClick={() => setTripType("R")}
                            >
                                Round trip
                            </button>
                        </div>

                        <form onSubmit={handleSearch}>
                            <div className="fs-fields">

                                {/* FROM */}
                                <div className="fs-field fs-field-route" ref={fromRef}>
                                    <label className="fs-label">From</label>
                                    <input
                                        type="text"
                                        className="fs-input"
                                        value={fromQuery}
                                        onBlur={handleFromBlur}
                                        onChange={handleFromChange}
                                        onFocus={(e) => handleInputFocus("from", e)}
                                        placeholder="City or airport"
                                        autoComplete="off"
                                    />
                                    <span className="fs-sublabel">{from.code} &middot; {from.name}</span>

                                    {fromSuggestions.length > 0 && (
                                        <ul className="fs-suggestions">
                                            {fromSuggestions.map((airport, index) => (
                                                <li
                                                    key={airport.ID || index}
                                                    onMouseDown={(e) => { e.preventDefault(); selectFromAirport(airport); }}
                                                >
                                                    <span className="fs-sugg-main">{airport.CityName} <span className="fs-sugg-code">{airport.AirportCode}</span>{!isIndianAirport(airport) && <span className="fs-sugg-tag">Intl</span>}</span>
                                                    <span className="fs-sugg-sub">{airport.AirportName}{(airport.CountryName || airport.Country) ? ` · ${airport.CountryName || airport.Country}` : ""}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {fromSuggestions.length === 0 && fromQuery.trim().length >= 3 && airportsStatus !== "ready" && (
                                        <div className="fs-suggestions fs-suggestions-status">
                                            {airportsStatus === "loading" ? "Loading airports…" : "Couldn't load airport list. Please refresh."}
                                        </div>
                                    )}

                                    <button type="button" className="fs-swap" onClick={handleSwap} aria-label="Swap origin and destination">
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M7 16V4M7 4L3 8M7 4l4 4" />
                                            <path d="M17 8v12m0 0l4-4m-4 4l-4-4" />
                                        </svg>
                                    </button>
                                </div>

                                <div className="fs-field fs-field-route" ref={toRef}>
                                    <label className="fs-label">To</label>
                                    <input
                                        type="text"
                                        className="fs-input"
                                        value={toQuery}
                                        onChange={handleToChange}
                                        onFocus={(e) => handleInputFocus("to", e)}
                                        onBlur={handleToBlur}
                                        placeholder="City or airport"
                                        autoComplete="off"
                                    />
                                    <span className="fs-sublabel">{to.code} &middot; {to.name}</span>

                                    {toSuggestions.length > 0 && (
                                        <ul className="fs-suggestions">
                                            {toSuggestions.map((airport, index) => (
                                                <li
                                                    key={airport.ID || index}
                                                    onMouseDown={(e) => { e.preventDefault(); selectToAirport(airport); }}
                                                >
                                                    <span className="fs-sugg-main">{airport.CityName} <span className="fs-sugg-code">{airport.AirportCode}</span>{!isIndianAirport(airport) && <span className="fs-sugg-tag">Intl</span>}</span>
                                                    <span className="fs-sugg-sub">{airport.AirportName}{(airport.CountryName || airport.Country) ? ` · ${airport.CountryName || airport.Country}` : ""}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                    {toSuggestions.length === 0 && toQuery.trim().length >= 3 && airportsStatus !== "ready" && (
                                        <div className="fs-suggestions fs-suggestions-status">
                                            {airportsStatus === "loading" ? "Loading airports…" : "Couldn't load airport list. Please refresh."}
                                        </div>
                                    )}
                                </div>

                                {/* DEPART */}
                                <div
                                    className="fs-field fs-field-date"
                                    onClick={() => departInputRef.current?.showPicker?.()}
                                >
                                    <label className="fs-label">Departure</label>
                                    <input
                                        ref={departInputRef}
                                        type="date"
                                        className="fs-date-input"
                                        value={departDate}
                                        onChange={handleDepartDateChange}
                                        min={toLocalDateStr(new Date())}
                                    />
                                    <div className="fs-date-display">
                                        <span className="fs-date-day">{departDisplay.day}</span>
                                        <span className="fs-date-month">{departDisplay.month} {departDisplay.year}</span>
                                    </div>
                                    <span className="fs-sublabel">{departDisplay.dayName}</span>
                                </div>

                                {/* RETURN */}
                                {tripType === "R" && (
                                    <div
                                        className="fs-field fs-field-date"
                                        onClick={() => returnInputRef.current?.showPicker?.()}
                                    >
                                        <label className="fs-label">Return</label>
                                        <input
                                            ref={returnInputRef}
                                            type="date"
                                            className="fs-date-input"
                                            value={returnDate}
                                            onChange={handleReturnDateChange}
                                            min={departDate}
                                        />
                                        <div className="fs-date-display">
                                            <span className="fs-date-day">{returnDisplay.day}</span>
                                            <span className="fs-date-month">{returnDisplay.month} {returnDisplay.year}</span>
                                        </div>
                                        <span className="fs-sublabel">{returnDisplay.dayName}</span>
                                    </div>
                                )}

                                {/* TRAVELERS */}
                                <div className="fs-field fs-field-travelers" ref={travelerRef}>
                                    <div onClick={() => setShowTravelerDropdown(!showTravelerDropdown)} style={{ cursor: "pointer" }}>
                                        <label className="fs-label">Travelers &amp; class</label>
                                        <div className="fs-date-display">
                                            <span className="fs-date-day">{totalTravelers}</span>
                                            <span className="fs-date-month">Traveler{totalTravelers > 1 ? "s" : ""}</span>
                                        </div>
                                        <span className="fs-sublabel">{travelClass}</span>
                                    </div>

                                    {showTravelerDropdown && (
                                        <div className="fs-traveler-dropdown" onClick={(e) => e.stopPropagation()}>
                                            {[
                                                { label: "Adults", sub: "12+ yrs", val: adults, set: setAdults },
                                                { label: "Children", sub: "2–12 yrs", val: children, set: setChildren },
                                                { label: "Infants", sub: "Under 2 yrs", val: infants, set: setInfants }
                                            ].map((item, idx) => {
                                                const isAdultOrChild = item.label === "Adults" || item.label === "Children";
                                                const canIncrease = isAdultOrChild ? (adults + children < 9) : (infants < 9);
                                                const canDecrease = item.label === "Adults" ? item.val > 1 : item.val > 0;

                                                return (
                                                    <div key={idx} className="fs-traveler-row">
                                                        <div>
                                                            <div className="fs-traveler-label">{item.label}</div>
                                                            <div className="fs-traveler-sub">{item.sub}</div>
                                                        </div>
                                                        <div className="fs-stepper">
                                                            <button type="button" disabled={!canDecrease} onClick={() => item.set(item.val - 1)}>&minus;</button>
                                                            <span>{item.val}</span>
                                                            <button type="button" disabled={!canIncrease} onClick={() => item.set(item.val + 1)}>+</button>
                                                        </div>
                                                    </div>
                                                );
                                            })}

                                            <div className="fs-class-section">
                                                <div className="fs-class-title">Travel class</div>
                                                <div className="fs-class-grid">
                                                    {["Economy", "Premium Economy", "Business", "First Class"].map((cls) => (
                                                        <button
                                                            key={cls}
                                                            type="button"
                                                            className={`fs-class-btn ${travelClass === cls ? "active" : ""}`}
                                                            onClick={() => setTravelClass(cls)}
                                                        >
                                                            {cls}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>

                                            <button
                                                type="button"
                                                className="fs-done-btn"
                                                onClick={() => setShowTravelerDropdown(false)}
                                            >
                                                Done
                                            </button>
                                        </div>
                                    )}
                                </div>

                                {/* SEARCH */}
                                <div className="fs-field fs-field-submit">
                                    <button type="submit" className="fs-search-btn" disabled={isSearching}>
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <circle cx="11" cy="11" r="8" />
                                            <path d="M21 21l-4.3-4.3" />
                                        </svg>
                                        Search flights
                                    </button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </section>

            <TrendingRoutes />
            <WhyBooking />

            {/* ===== CHAT LAUNCH BUTTON ===== */}
            <button className="fs-chat-btn" onClick={() => setIsChatOpen(true)}>
                <span className="fs-chat-icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <rect x="3" y="5" width="18" height="14" rx="4" />
                        <circle cx="9" cy="12" r="1" />
                        <circle cx="15" cy="12" r="1" />
                    </svg>
                </span>
                <span className="fs-chat-text">Ask me anything!</span>
            </button>

            {isChatOpen && (
                <div className="fs-chat-overlay" onClick={() => setIsChatOpen(false)}>
                    <div className="fs-chat-modal" onClick={(e) => e.stopPropagation()}>

                        <div className="fs-chat-header">
                            <button className="fs-chat-close" onClick={() => setIsChatOpen(false)}>✕</button>
                            <div className="fs-chat-logo">
                                Kudo<span className="fs-chat-logo-dot"></span>
                                <sup className="fs-chat-beta">beta</sup>
                            </div>
                            <button className="fs-chat-menu">⋯</button>
                        </div>

                        <div className="fs-chat-body" ref={chatBodyRef}>
                            {messages.length === 0 && (
                                <>
                                    <h2 className="fs-chat-greeting">Hi, There</h2>
                                    <p className="fs-chat-intro">
                                        <strong>I'm Kudo</strong> — your personal travel assistant. Let's plan your next trip together.
                                    </p>

                                    <div className="fs-chat-suggest-label">You may try asking</div>

                                    <div className="fs-chat-suggestions">
                                        {[
                                            "Cheapest Flights Mumbai to Delhi next week",
                                            "What documents do I need to travel?",
                                            "Help me plan my trip"
                                        ].map((q, idx) => (
                                            <button key={idx} className="fs-chat-suggest-card" onClick={() => handleUserMessage(q)}>
                                                <span className="fs-chat-suggest-icon">✈️</span>
                                                <span>{q}</span>
                                            </button>
                                        ))}
                                    </div>
                                </>
                            )}

                            {messages.length > 0 && (
                                <div className="fs-chat-messages">
                                    {messages.map((m, idx) => (
                                        <div key={idx} className={`fs-msg fs-msg-${m.role}`}>
                                            {m.text}
                                        </div>
                                    ))}
                                    {isBotTyping && (
                                        <div className="fs-msg fs-msg-bot fs-msg-typing">Typing...</div>
                                    )}
                                </div>
                            )}
                        </div>

                        <div className="fs-chat-input-bar">
                            <input
                                type="text"
                                placeholder="Ask me anything"
                                className="fs-chat-input"
                                value={userInput}
                                onChange={(e) => setUserInput(e.target.value)}
                                onKeyDown={(e) => e.key === "Enter" && handleUserMessage(userInput)}
                            />
                            <button className="fs-chat-send" onClick={() => handleUserMessage(userInput)} disabled={isBotTyping}>
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5">
                                    <path d="M12 19V5M12 5l-6 6M12 5l6 6" />
                                </svg>
                            </button>
                        </div>

                    </div>
                </div>
            )}

          <style>{`
                .fs-page {
                    --fs-navy: #1a2b6d;
                    --fs-navy-deep: #0f1a4a;
                    --fs-sky: #2451c4;
                    --fs-sunset-1: #e63950;
                    --fs-sunset-2: #ff6b7a;
                    --fs-ink: #14213d;
                    --fs-muted: #6b7688;
                    --fs-border: #e4e8f0;
                    --fs-bg: #f6f8fc;
                    overflow-x: hidden;
                    -webkit-tap-highlight-color: transparent;
                }
                .fs-page *, .fs-page *::before, .fs-page *::after { box-sizing: border-box; }

                .fs-hero {
                    position: relative;
                    padding: 64px 20px 120px;
                    min-height: 560px;
                }
                .fs-hero-bg {
                    position: absolute; inset: 0; z-index: 0;
                    overflow: hidden;
                    border-radius: inherit;
                }
                .fs-hero-slide {
                    position: absolute; inset: 0;
                    background-size: cover;
                    background-position: center;
                    transition: opacity 1.8s ease-in-out;
                }
                .fs-hero-overlay {
                    position: absolute; inset: 0;
                    background: linear-gradient(180deg, rgba(6,26,51,0.75) 0%, rgba(11,37,69,0.55) 45%, rgba(11,37,69,0.85) 100%);
                }
                .fs-hero-dots {
                    position: absolute;
                    bottom: 28px; left: 50%;
                    transform: translateX(-50%);
                    display: flex; gap: 8px;
                    z-index: 2;
                }
                .fs-dot {
                    width: 8px; height: 8px; border-radius: 50%;
                    border: none; padding: 0; cursor: pointer;
                    background: rgba(255,255,255,0.4);
                    transition: all 0.3s ease;
                }
                .fs-dot.active { background: #fff; width: 22px; border-radius: 4px; }

                .fs-container {
                    position: relative; z-index: 1;
                    max-width: 1180px; margin: 0 auto;
                    text-align: center;
                }
                .fs-eyebrow {
                    color: var(--fs-sunset-2);
                    font-size: 13px; font-weight: 600;
                    letter-spacing: 0.12em; text-transform: uppercase;
                    margin: 0 0 12px;
                }
                .fs-heading {
                    color: #fff;
                    font-size: clamp(26px, 6vw, 44px);
                    font-weight: 700;
                    line-height: 1.15;
                    margin: 0 0 12px;
                    letter-spacing: -0.02em;
                }
                .fs-subheading {
                    color: rgba(255,255,255,0.8);
                    font-size: 16px;
                    margin: 0 0 36px;
                }
                .fs-card {
                    background: rgba(255,255,255,0.97);
                    backdrop-filter: blur(12px);
                    border-radius: 20px;
                    box-shadow: 0 24px 60px rgba(6,26,51,0.35), 0 2px 8px rgba(6,26,51,0.08);
                    padding: 22px 22px 26px;
                    text-align: left;
                }
                .fs-triptype {
                    display: inline-flex;
                    background: var(--fs-bg);
                    border-radius: 10px;
                    padding: 4px;
                    margin-bottom: 20px;
                    gap: 4px;
                }
                .fs-trip-btn {
                    border: none; background: transparent;
                    padding: 9px 20px; border-radius: 7px;
                    font-size: 14px; font-weight: 600;
                    color: var(--fs-muted);
                    cursor: pointer; transition: all 0.2s ease;
                }
                .fs-trip-btn.active { background: var(--fs-navy); color: #fff; }

                .fs-fields {
                    display: grid;
                    grid-template-columns: 1.4fr 1.4fr 1fr 1fr 1.1fr auto;
                    gap: 0;
                    border: 1px solid var(--fs-border);
                    border-radius: 14px;
                    overflow: visible;
                }
                .fs-field {
                    position: relative;
                    padding: 14px 18px;
                    border-right: 1px solid var(--fs-border);
                    min-width: 0;
                }
                .fs-field:last-child { border-right: none; }
                .fs-label {
                    display: block;
                    font-size: 11px; font-weight: 600;
                    text-transform: uppercase; letter-spacing: 0.06em;
                    color: var(--fs-muted);
                    margin-bottom: 6px;
                }
                .fs-input {
                    border: none; outline: none;
                    width: 100%; font-size: 18px; font-weight: 700;
                    color: var(--fs-ink); background: transparent;
                    padding: 0; font-family: inherit;
                    text-overflow: ellipsis;
                }
                .fs-input::placeholder { color: #b7bfcc; font-weight: 500; }
                .fs-sublabel {
                    display: block;
                    font-size: 12px; color: var(--fs-muted);
                    margin-top: 4px;
                    white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
                }
                .fs-swap {
                    position: absolute;
                    right: -14px; top: 50%;
                    transform: translateY(-50%);
                    width: 30px; height: 30px;
                    border-radius: 50%;
                    background: var(--fs-navy);
                    color: #fff;
                    border: 3px solid #fff;
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer; z-index: 5;
                    box-shadow: 0 2px 8px rgba(11,37,69,0.3);
                    transition: transform 0.2s ease;
                    padding: 0;
                }
                .fs-swap:hover { transform: translateY(-50%) rotate(180deg); }

                .fs-suggestions {
                    position: absolute; top: calc(100% + 6px); left: 8px; right: 8px;
                    z-index: 50; background: #fff;
                    border: 1px solid var(--fs-border);
                    border-radius: 12px;
                    list-style: none; margin: 0; padding: 6px;
                    max-height: 260px; overflow-y: auto;
                    -webkit-overflow-scrolling: touch;
                    box-shadow: 0 12px 28px rgba(6,26,51,0.18);
                }
                .fs-suggestions li {
                    cursor: pointer; padding: 10px 10px;
                    border-radius: 8px;
                    display: flex; flex-direction: column; gap: 2px;
                }
                .fs-suggestions li:hover { background: var(--fs-bg); }
                .fs-sugg-main { font-size: 14px; font-weight: 600; color: var(--fs-ink); }
                .fs-sugg-code { color: var(--fs-sky); font-weight: 700; }
                .fs-sugg-sub { font-size: 12px; color: var(--fs-muted); }
                .fs-sugg-tag { font-size: 10px; font-weight: 700; color: #fff; background: var(--fs-sky); border-radius: 4px; padding: 1px 6px; margin-left: 6px; vertical-align: middle; }
                .fs-suggestions-status { padding: 10px 12px; font-size: 13px; color: var(--fs-muted); }

                .fs-date-input {
                    position: absolute; inset: 0; opacity: 0;
                    width: 100%; height: 100%; cursor: pointer;
                    font-size: 16px;
                }
                .fs-date-display { display: flex; align-items: baseline; gap: 6px; }
                .fs-date-day { font-size: 22px; font-weight: 700; color: var(--fs-ink); }
                .fs-date-month { font-size: 13px; font-weight: 600; color: var(--fs-muted); }

                .fs-field-travelers { cursor: pointer; }
                .fs-traveler-dropdown {
                    position: absolute; top: calc(100% + 8px); right: 0;
                    z-index: 60; background: #fff;
                    border: 1px solid var(--fs-border);
                    border-radius: 14px;
                    box-shadow: 0 16px 36px rgba(6,26,51,0.2);
                    width: 300px; max-width: calc(100vw - 32px); padding: 18px;
                }
                .fs-traveler-row { display: flex; justify-content: space-between; align-items: center; padding: 8px 0; }
                .fs-traveler-label { font-size: 14px; font-weight: 600; color: var(--fs-ink); }
                .fs-traveler-sub { font-size: 12px; color: var(--fs-muted); }
                .fs-stepper { display: flex; align-items: center; gap: 12px; }
                .fs-stepper button {
                    width: 28px; height: 28px; border-radius: 50%;
                    border: 1px solid var(--fs-border); background: #fff;
                    color: var(--fs-navy); font-size: 16px; line-height: 1;
                    cursor: pointer; display: flex; align-items: center; justify-content: center;
                    transition: all 0.15s ease; padding: 0;
                }
                .fs-stepper button:hover:not(:disabled) { background: var(--fs-navy); color: #fff; border-color: var(--fs-navy); }
                .fs-stepper button:disabled { opacity: 0.35; cursor: not-allowed; }
                .fs-stepper span { min-width: 18px; text-align: center; font-weight: 700; color: var(--fs-ink); }

                .fs-class-section { margin-top: 14px; padding-top: 14px; border-top: 1px solid var(--fs-border); }
                .fs-class-title { font-size: 13px; font-weight: 700; color: var(--fs-ink); margin-bottom: 10px; }
                .fs-class-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
                .fs-class-btn {
                    padding: 9px; border-radius: 8px;
                    border: 1px solid var(--fs-border); background: #fff;
                    font-size: 13px; font-weight: 600; color: var(--fs-ink);
                    cursor: pointer; transition: all 0.15s ease;
                }
                .fs-class-btn.active { background: var(--fs-navy); border-color: var(--fs-navy); color: #fff; }

                .fs-done-btn {
                    margin-top: 16px; width: 100%; padding: 10px;
                    border: none; border-radius: 8px;
                    background: var(--fs-navy); color: #fff;
                    font-size: 14px; font-weight: 700; cursor: pointer;
                }

                .fs-field-submit { padding: 10px; display: flex; align-items: center; }
                .fs-search-btn {
                    display: flex; align-items: center; justify-content: center; gap: 8px;
                    height: 56px; padding: 0 26px;
                    border: none; border-radius: 12px;
                    background: linear-gradient(135deg, var(--fs-sunset-1), var(--fs-sunset-2));
                    color: #fff; font-size: 15px; font-weight: 700;
                    cursor: pointer; white-space: nowrap;
                    box-shadow: 0 10px 24px rgba(255,122,69,0.35);
                    transition: transform 0.15s ease, box-shadow 0.15s ease;
                }
                .fs-search-btn:hover { transform: translateY(-2px); box-shadow: 0 14px 28px rgba(255,122,69,0.45); }
                .fs-search-btn:disabled { opacity: 0.7; cursor: not-allowed; transform: none; }

                /* ===== TABLET (<=1024px): 2-column, each field is its own card ===== */
                @media (max-width: 1024px) {
                    .fs-hero { padding: 52px 18px 100px; min-height: 0; }
                    .fs-subheading { margin-bottom: 26px; }
                    .fs-fields {
                        grid-template-columns: 1fr 1fr;
                        gap: 10px;
                        border: none;
                    }
                    .fs-field {
                        border: 1px solid var(--fs-border);
                        border-radius: 12px;
                        background: #fff;
                    }
                    .fs-field:last-child { border: none; }
                    .fs-field-submit {
                        grid-column: 1 / -1;
                        padding: 0; background: transparent;
                    }
                    .fs-search-btn { width: 100%; }
                    /* swap sits in the gap between From and To */
                    .fs-swap { right: -20px; }
                }

                /* ===== MOBILE (<=560px): single column ===== */
                @media (max-width: 560px) {
                    .fs-hero { padding: 36px 12px 84px; }
                    .fs-eyebrow { font-size: 11px; margin-bottom: 8px; }
                    .fs-subheading { font-size: 14px; margin-bottom: 20px; }
                    .fs-card { padding: 14px 12px 14px; border-radius: 16px; }

                    .fs-triptype { display: flex; width: 100%; margin-bottom: 14px; }
                    .fs-trip-btn { flex: 1; padding: 11px 10px; }

                    .fs-fields { grid-template-columns: 1fr; gap: 10px; }
                    .fs-field { padding: 12px 14px; }
                    .fs-input { font-size: 17px; }

                    /* swap button: right side, centered on the gap between From and To */
                    .fs-swap {
                        right: 14px; top: auto; bottom: -20px;
                        transform: none;
                        width: 34px; height: 34px;
                    }
                    .fs-swap:hover { transform: none; }
                    .fs-swap:active { transform: rotate(180deg); }

                    /* dropdowns span the whole field */
                    .fs-suggestions { left: 0; right: 0; max-height: 220px; }
                    .fs-suggestions li { padding: 12px 10px; }

                    .fs-traveler-dropdown {
                        right: 0; left: 0; width: auto; max-width: none;
                        padding: 14px;
                    }
                    .fs-stepper { gap: 16px; }
                    .fs-stepper button { width: 36px; height: 36px; font-size: 18px; }
                    .fs-class-btn { padding: 12px 8px; }
                    .fs-done-btn { padding: 13px; }

                    .fs-search-btn { height: 52px; }
                    .fs-hero-dots { bottom: 20px; }
                }

                /* ===== CHATBOT ===== */
                .fs-chat-btn {
                    position: fixed; right: 20px; bottom: 20px; z-index: 100;
                    display: flex; align-items: center; gap: 10px;
                    background: #fff; border: none; border-radius: 999px;
                    padding: 8px 20px 8px 8px;
                    box-shadow: 0 8px 24px rgba(6,26,51,0.2);
                    cursor: pointer;
                    transition: transform 0.2s ease, box-shadow 0.2s ease;
                }
                .fs-chat-btn:hover { transform: translateY(-2px); box-shadow: 0 12px 28px rgba(6,26,51,0.28); }
                .fs-chat-icon {
                    width: 40px; height: 40px; border-radius: 50%;
                    background: linear-gradient(135deg, var(--fs-sky), var(--fs-navy));
                    color: #fff;
                    display: flex; align-items: center; justify-content: center;
                }
                .fs-chat-text { font-size: 14px; font-weight: 700; color: var(--fs-navy); }

                .fs-chat-overlay {
                    position: fixed; inset: 0; z-index: 200;
                    display: flex; align-items: flex-end; justify-content: center;
                }
                .fs-chat-modal {
                    position: fixed; right: 0; bottom: 3px;
                    width: 355px; max-width: calc(100vw - 40px);
                    height: 560px; max-height: calc(100vh - 120px);
                    background: #fff; border-radius: 20px;
                    display: flex; flex-direction: column;
                    box-shadow: 0 20px 50px rgba(6,26,51,0.3);
                    animation: fsSlideUp 0.25s ease;
                }
                @keyframes fsSlideUp {
                    from { transform: translateY(40px); opacity: 0; }
                    to { transform: translateY(0); opacity: 1; }
                }
                .fs-chat-header { display: flex; align-items: center; justify-content: space-between; padding: 16px 18px; flex-shrink: 0; }
                .fs-chat-close, .fs-chat-menu {
                    width: 36px; height: 36px; border-radius: 50%;
                    border: 1px solid var(--fs-border); background: #fff;
                    font-size: 15px; cursor: pointer;
                    display: flex; align-items: center; justify-content: center;
                }
                .fs-chat-logo {
                    font-family: cursive, sans-serif; font-size: 20px; font-weight: 700;
                    color: var(--fs-sky);
                    display: flex; align-items: flex-start; gap: 2px;
                }
                .fs-chat-beta { font-size: 10px; font-weight: 700; color: var(--fs-muted); margin-left: 2px; }
                .fs-chat-body {
                    flex: 1; overflow-y: auto; padding: 10px 22px;
                    -webkit-overflow-scrolling: touch; overscroll-behavior: contain;
                }
                .fs-chat-greeting { font-size: 32px; font-weight: 800; color: var(--fs-sky); margin: 10px 0 14px; }
                .fs-chat-intro { font-size: 15px; color: var(--fs-ink); line-height: 1.5; margin-bottom: 24px; }
                .fs-chat-suggest-label { font-size: 13px; color: var(--fs-muted); margin-bottom: 12px; }
                .fs-chat-suggestions { display: flex; flex-direction: column; gap: 12px; }
                .fs-chat-suggest-card {
                    display: flex; align-items: center; gap: 14px;
                    padding: 14px 16px;
                    border: 1px solid var(--fs-border); border-radius: 14px;
                    background: #fff; font-size: 14px; font-weight: 500;
                    color: var(--fs-ink); text-align: left; cursor: pointer;
                    transition: background 0.15s ease;
                }
                .fs-chat-suggest-card:hover { background: var(--fs-bg); }
                .fs-chat-suggest-icon {
                    width: 36px; height: 36px; border-radius: 8px;
                    background: #ece5fb;
                    display: flex; align-items: center; justify-content: center;
                    font-size: 16px; flex-shrink: 0;
                }
                .fs-chat-input-bar {
                    display: flex; align-items: center; gap: 10px;
                    padding: 14px 16px; border-top: 1px solid var(--fs-border);
                    flex-shrink: 0;
                }
                .fs-chat-input {
                    flex: 1; min-width: 0; border: none; outline: none;
                    font-size: 16px; /* 16px stops iOS from zooming on focus */
                    color: var(--fs-ink); background: transparent;
                }
                .fs-chat-input::placeholder { color: var(--fs-muted); }
                .fs-chat-send {
                    width: 38px; height: 38px; border-radius: 50%; border: none;
                    background: var(--fs-sky);
                    display: flex; align-items: center; justify-content: center;
                    cursor: pointer; flex-shrink: 0;
                }
                .fs-chat-send:disabled { opacity: 0.6; cursor: not-allowed; }
                .fs-chat-messages { display: flex; flex-direction: column; gap: 12px; padding: 8px 0; }
                .fs-msg { max-width: 85%; padding: 10px 14px; border-radius: 14px; font-size: 14px; line-height: 1.4; word-break: break-word; }
                .fs-msg-user { align-self: flex-end; background: var(--fs-navy); color: #fff; border-bottom-right-radius: 4px; }
                .fs-msg-bot { align-self: flex-start; background: var(--fs-bg); color: var(--fs-ink); border-bottom-left-radius: 4px; }
                .fs-msg-typing { color: var(--fs-muted); font-style: italic; }

                @media (min-width: 561px) {
                    .fs-chat-overlay { align-items: center; }
                    .fs-chat-modal { border-radius: 24px; max-height: 85vh; }
                }

                /* chat on phones: full-width bottom sheet */
                @media (max-width: 560px) {
                    .fs-chat-text { display: none; }
                    .fs-chat-btn {
                        padding: 8px;
                        right: 14px;
                        bottom: calc(14px + env(safe-area-inset-bottom));
                    }
                    .fs-chat-overlay { background: rgba(6,26,51,0.45); }
                    .fs-chat-modal {
                        left: 0; right: 0; bottom: 0;
                        width: 100%; max-width: 100%;
                        height: 92vh; height: 92dvh;
                        max-height: 92dvh;
                        border-radius: 20px 20px 0 0;
                    }
                    .fs-chat-header { padding: 12px 14px; }
                    .fs-chat-body { padding: 8px 16px; }
                    .fs-chat-greeting { font-size: 26px; }
                    .fs-chat-input-bar {
                        padding: 10px 14px calc(10px + env(safe-area-inset-bottom));
                    }
                    .fs-chat-send { width: 42px; height: 42px; }
                    .fs-msg { max-width: 90%; }
                }
            `}</style>
        </div>
    );
}

export default Index;